import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Paper,
  Divider,
  Slide,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { useCheckout } from "./CheckoutContext";

const PaymentSuccessful = () => {
  const [searchParams] = useSearchParams();
  const reference = searchParams.get("reference");
  const navigate = useNavigate();
  const { dispatch } = useCheckout();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Clear cart and redirect after 10 seconds
  useEffect(() => {
    // Fire Purchase pixel event
    window.fbq &&
      window.fbq("track", "Purchase", {
        value: searchParams.get("amount") || 0, // pass amount if available
        currency: "USD", // or dynamic from backend
        contents: [
          {
            id: reference, // transaction or order ID
            quantity: 1,
          },
        ],
      });
    dispatch({ type: "CLEAR_CART" });
    const timer = setTimeout(() => {
      navigate("/");
    }, 10000);
    return () => clearTimeout(timer);
  }, [navigate, dispatch]);

  return (
    <Slide direction="up" in mountOnEnter unmountOnExit>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
        bgcolor="#f0f4f8"
        px={2}
      >
        <Paper
          elevation={6}
          sx={{
            p: isMobile ? 3 : 5,
            borderRadius: 4,
            maxWidth: 500,
            width: "100%",
            textAlign: "center",
            bgcolor: "#ffffff",
          }}
        >
          <CheckCircleOutlineIcon
            sx={{ fontSize: 80, color: "#4caf50", mb: 2 }}
          />
          <Typography variant="h4" fontWeight="600" gutterBottom>
            Payment Successful!
          </Typography>
          <Typography variant="body1" color="text.secondary" mb={2}>
            Thank you for your trust! You’ll be redirected to the homepage
            shortly.
          </Typography>
          <Divider sx={{ my: 2 }} />
          {reference && (
            <Typography variant="subtitle2" color="text.secondary">
              Reference ID:
              <Typography
                variant="body1"
                component="span"
                color="text.primary"
                fontWeight="bold"
              >
                {" "}
                {reference}
              </Typography>
            </Typography>
          )}
          <Button
            variant="contained"
            color="success"
            sx={{ mt: 4, px: 4, py: 1.2, borderRadius: "30px" }}
            onClick={() => navigate("/")}
          >
            Return to Home Now
          </Button>
        </Paper>
      </Box>
    </Slide>
  );
};

export default PaymentSuccessful;
